import { render } from "./RealEstateAssetMap.vue?vue&type=template&id=65f181c4&scoped=true"
import script from "./RealEstateAssetMap.vue?vue&type=script&lang=ts"
export * from "./RealEstateAssetMap.vue?vue&type=script&lang=ts"

import "./RealEstateAssetMap.vue?vue&type=style&index=0&id=65f181c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65f181c4"

export default script